<template>
  <div class="p-relative">
    <div v-if="$route.name === 'ThegraphProjectDetails'">
      <div
        class="text-6 gray--text d-flex align-center clickable"
        @click="
          $router.push({
            name: 'Yield',
          })
        "
      >
        <v-icon small class="gray--text">mdi-chevron-left</v-icon>
        <span class="ml-1">Go Back</span>
      </div>
      <project-overview class="mt-8" />
      <v-divider class="mt-4 border-stake"></v-divider>
      <div class="mt-10">
        <about />
        <v-divider class="mt-10 mb-10 border-stake"></v-divider>
        <your-balance />
        <v-divider class="mt-10 mb-10 border-stake"></v-divider>
        <c-faq-section />
        <v-divider class="mt-10 mb-10 border-stake"></v-divider>
        <div class="d-none d-md-block">
          <div class="text-4 mb-10">Explore More</div>
          <link-cards />
        </div>
      </div>
      <c-fullscreen-modal
        v-if="shouldShowTxModal"
        @back="hideTxModal"
        @close="hideTxModal"
      >
        <tx @close="hideTxModal" />
      </c-fullscreen-modal>
    </div>
    <router-view v-else></router-view>
    <c-loading v-if="showLoading" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProjectOverview from "../../components/ProjectOverview";
import About from "./components/About";
import AboutToken from "@/views/stake/components/AboutToken";
import YourBalance from "./components/YourBalance";
import LinkCards from "@/views/explore/components/LinkCards";
import Tx from "./tx";

import { regsiterVuexModules } from "@/common/lib/utils";
import store from "@/store";
import thegraphModule from "@/store/modules/staking/ethereum/thegraph.module";
regsiterVuexModules(store, { "staking/thegraph": thegraphModule });

export default {
  components: {
    ProjectOverview,
    About,
    AboutToken,
    YourBalance,
    LinkCards,
    Tx,
  },
  computed: mapGetters({
    walletSelected: "userWallets/walletSelected",
    currentProject: "projectConfig/latestProject",
  }),
  data: () => ({
    showLoading: false,
    shouldShowTxModal: false,
  }),
  methods: {
    async fetchStakingDetails() {
      this.showLoading = true;
      await this.$store.dispatch("staking/thegraph/fetchRequiredInfo");
      this.showLoading = false;
    },
    async fetchNetworkInfo() {
      this.showLoading = true;
      await this.$store.dispatch("staking/thegraph/fetchNetworkInfo");
      this.showLoading = false;
    },
    hideTxModal() {
      this.shouldShowTxModal = false;
      this.resetAction();
    },
    resetAction() {
      this.$router.replace({
        name: this.$route.name,
      });
    },
  },
  watch: {
    ["walletSelected.address"]: {
      immediate: true,
      handler(address) {
        this.$store.dispatch("staking/thegraph/resetState");
        if (address && address.startsWith("0x")) {
          this.fetchStakingDetails();
        }
      },
    },
    ["currentProject.name"]: {
      immediate: true,
      handler(value) {
        if (value === "thegraph") {
          this.fetchNetworkInfo();
        }
      },
    },
    $route: {
      immediate: true,
      handler() {
        if (this.$route.query.action === "tx") {
          this.shouldShowTxModal = true;
        }
      },
    },
  },
};
</script>
